export const fetchOpenCohorts = (app, lang, program) => {
  const now = new Date();

  return app.cohort.findMany({
    where: {
      ...(typeof program?.id === 'number' && {
        programId: program.id,
      }),
      admissionCountries: {
        isEmpty: false,
      },
      stage: {
        name: 'bootcamp',
      },
      lang,
      start: {
        gt: now,
      },
      admissionStart: {
        not: null,
        lte: now,
      },
      admissionEnd: {
        not: null,
        gte: now,
      },
    },
    include: {
      program: true,
      stage: true,
    },
    orderBy: {
      start: 'asc',
    },
  });
};
